import { BrowserRouter, Routes, Route } from 'react-router-dom';
import EventPage from './pages/raphael/event/EventPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/raphael/event" element={<EventPage />} />
        <Route path="/raphael/event/" element={<EventPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
